import { Box } from "@mui/material";
import React from "react";
import customImageListStyles from "../../assets/jss/material-dashboard-react/components/customImageListStyles";
import RequestImage from "../RequestImage/RequestImage";

const RequestImageList = ({ images, handleDelete }) => {

    return (
        <div style={customImageListStyles.root}>
            <Box sx={customImageListStyles.imageList}>
                {images?.length
                    ? images.map((image, index) => (
                        <RequestImage
                            handleDelete={() => handleDelete(image.part_request_image_id)}
                            image={image}
                            key={image.part_request_image_id}
                            index={index}
                        />
                    ))
                    : null}
            </Box>
        </div>
    );
};

export default RequestImageList;
